import { render } from "./UsersDeleteList.vue?vue&type=template&id=51405518&scoped=true"
import script from "./UsersDeleteList.vue?vue&type=script&lang=js"
export * from "./UsersDeleteList.vue?vue&type=script&lang=js"

import "./UsersDeleteList.vue?vue&type=style&index=0&id=51405518&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51405518"]])

export default __exports__